module.exports = __webpack_public_path__ + "static/img/bg-slight-production-galerija.9ca0ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galerija/bg-slight-production-galerija.jpg
// module id = P6kU
// module chunks = 1